export default {
  FirebaseConfig: {
    apiKey: "AIzaSyDNE0LIl1fCajP-7PWXGBIKpyKCyxvIT0c",
    authDomain: "loriinitribes.firebaseapp.com",
    databaseURL:
      "https://loriinitribes-default-rtdb.europe-west1.firebasedatabase.app",
    projectId: "loriinitribes",
    storageBucket: "loriinitribes.appspot.com",
    messagingSenderId: "897777474320",
  },
};
